<div class="EditCampaign p-3" *ngIf="componentReady">
  <div class="Breadcrumbs mb-">
    <div class="Breadcrumbs-items">
      <a [routerLink]="['/campaigns']"
        ><mat-icon class="Breadcrumbs-icon back"
          >keyboard_backspace</mat-icon
        ></a
      >
      <a class="Breadcrumbs-item first" [routerLink]="['/campaigns']"
        >Active Campaigns</a
      >
      <mat-icon class="Breadcrumbs-icon">chevron_right</mat-icon>
      <span class="Breadcrumbs-item first">New Campaign</span>
      <mat-icon class="Breadcrumbs-icon">chevron_right</mat-icon>
      <span class="Breadcrumbs-item">Campaign Wizard</span>
    </div>
  </div>
  <div class="EditCampaign-body mt-5 p-5">
    <div class="EditCampaign-body-info mb-5">
      <span>Create or update Your Campaign</span>
    </div>
    <div *ngIf="campaignNameMissingError" class="alert alert-danger">
      <p class="mb-0">Please enter campaign name</p>
    </div>
    <div *ngIf="campaignNameTaken" class="alert alert-danger">
      <p class="mb-0">
        Campaign with this name, already exists! Please, choose a different
        name!
      </p>
    </div>
    <div *ngIf="missingFrequency" class="alert alert-danger">
      <p class="mb-0">Please, choose a valid frequency for you campaign!</p>
    </div>
    <div class="EditCampaign-body-form">
      <form [formGroup]="formGroup" class="text-start">
        <div class="row">
          <div class="col col-4">
            <mat-label>Select Campaign Type</mat-label>
          </div>
          <div class="col col-8">
            <mat-radio-group
              aria-label="Select an option"
              formControlName="campaign_type"
              (change)="onCampaignTypeSelection($event)">
              <mat-radio-button class="bold-radio" value="Standard"
                >Standard</mat-radio-button
              >
              <mat-radio-button class="ms-3 bold-radio" value="Frequency"
                >Choose Frequency</mat-radio-button
              >
            </mat-radio-group>
          </div>
        </div>
        <div class="row">
          <div class="col col-4">
            <mat-label>Campaign Name</mat-label>
          </div>
          <div class="col col-8">
            <app-text-field
              class="w-100"
              placeholder="Campaign name"
              formControlName="campaign_name"></app-text-field>
          </div>
        </div>
        <div class="row">
          <div class="col col-8 offset-4">
            <app-button
              class="ms-3"
              [color]="createButton.color"
              [text]="getCreateButtonText()"
              [size]="createButton.size"
              [Click]="createButton.onClick"></app-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
